import * as types from './mutations-types'

const mutations = {
  [types.SET_TOKEN] (state, data) {
    state.token = data
  },
  [types.SET_SALES_FLAG] (state, data) {
    state.sales_flag = data
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js